import { render, staticRenderFns } from "./AutomationList.vue?vue&type=template&id=fdd27a6a"
import script from "./AutomationList.vue?vue&type=script&lang=js"
export * from "./AutomationList.vue?vue&type=script&lang=js"
import style0 from "./AutomationList.vue?vue&type=style&index=0&id=fdd27a6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports